<template>
  <!-- Offrir le premium à un compte (REDMINE-13728) : durée et motif. Sert sur
       la fiche d'un utilisateur et sur la page « Offrir un abonnement ». -->
  <v-dialog :value="value" max-width="520" :persistent="saving" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>{{ $t('intranet.billing.grants.offer') }}</v-card-title>
      <v-card-subtitle v-if="userLabel">{{ userLabel }}</v-card-subtitle>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-select v-model="offer.duration" :items="durations" :label="$t('intranet.billing.grants.duration')" />
          <v-text-field v-if="offer.duration === 'date'" v-model="offer.until" type="date" :min="today"
                        :label="$t('intranet.billing.grants.until')" :rules="[v => (!!v && v > today) || $t('intranet.billing.grants.dateRequired')]" />
          <v-text-field v-model="offer.reason" :label="$t('intranet.billing.grants.reason')" :hint="$t('intranet.billing.grants.reasonHint')"
                        persistent-hint :rules="[v => (!!v && !!v.trim()) || $t('intranet.billing.grants.reasonRequired')]" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text :disabled="saving" @click="$emit('input', false)">{{ $t('intranet.referential.button.cancel') }}</v-btn>
        <v-btn depressed color="primary" :loading="saving" :disabled="!valid" @click="save()">
          {{ $t('intranet.billing.grants.offer') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { errorHandler } from 'aveine-toolbox'
import { offerGrant } from './billing-api'

/** Les durees proposees, en mois ; `date` et `none` a part. */
const MONTHS = { '1m': 1, '3m': 3, '1y': 12 }

export default {
  name: 'AveineGrantOfferDialog',
  props: {
    /** Ouvert ou non (v-model). */
    value: { type: Boolean, default: false },
    /** Le compte a qui offrir le premium. */
    userId: { type: String, default: null },
    /** Le nom ou l'email du compte, rappele sous le titre. */
    userLabel: { type: String, default: null }
  },
  data () {
    return { valid: false, saving: false, offer: this.blank() }
  },
  computed: {
    today () {
      return new Date().toISOString().slice(0, 10)
    },
    durations () {
      return ['1m', '3m', '1y', 'date', 'none'].map(value => ({ value, text: this.$t(`intranet.billing.grants.durations.${value}`) }))
    }
  },
  watch: {
    value (open) {
      if (open) this.offer = this.blank()
    }
  },
  methods: {
    blank () {
      return { duration: '1m', until: null, reason: '' }
    },
    /** La fin choisie, en ISO, ou `null` pour sans fin. */
    end () {
      if (this.offer.duration === 'none') return null
      if (this.offer.duration === 'date') return new Date(`${this.offer.until}T23:59:59`).toISOString()
      const end = new Date()
      end.setMonth(end.getMonth() + MONTHS[this.offer.duration])
      return end.toISOString()
    },
    async save () {
      this.saving = true
      try {
        await offerGrant(this.$auth, this.userId, this.offer.reason.trim(), this.end())
        this.$toastr.s(this.$t('intranet.billing.grants.offered'))
        this.$emit('input', false)
        this.$emit('offered')
      } catch (errors) {
        errorHandler(errors, this)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
